import gql from 'graphql-tag';

export default gql`
  mutation register($input: RegisterInput!) {
    register(input: $input)
  }
`;
